import { ReactNode } from 'react';
import cx from 'classnames';

interface AvailabilityLineProps {
  children: ReactNode;
  isCompact?: boolean;
  shouldWrap?: boolean;
  isPrint?: boolean;
}

export const AvailabilityLine = ({
  children,
  isCompact = false,
  shouldWrap = false,
  isPrint = false
}: Readonly<AvailabilityLineProps>) => (
  <div
    className={cx('mb-0 cat-u-theme-typography-body-sm', {
      'd-flex': !isPrint,
      'cat-u-theme-typography-body-sm': !isCompact,
      'cat-u-theme-typography-footnote': isCompact,
      'text-nowrap': !shouldWrap
    })}
  >
    {children}
  </div>
);
